import React from 'react';
import {View, StyleSheet, ViewStyle, TextStyle} from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import {useDispatch, useSelector} from 'react-redux';
import {getAuthData} from 'redux/selectors/authSelector';
import colors from 'theme/Colors';
import {corner_radius, spacing} from 'theme/Units';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {RootNavigatorParams, Routes} from 'navigation/Routes';
import {
  PerformanceInsights,
  OngoingProjects,
  SmartSearch,
  TaskInsight,
} from 'components';
import {
  setCurrentSelectedProject,
  setProjectName,
} from 'redux/slices/projectSlice';
import {Text} from 'ui-kits';

export function DashboardScreen({
  navigation,
}: NativeStackScreenProps<RootNavigatorParams>) {
  const authData = useSelector(getAuthData);
  const dispatch = useDispatch();

  function goToViewAndManageProjects() {
    navigation.navigate(Routes.PROJECT, {screen: Routes.VIEWPROJECT} as any);
  }
  function goToProjectDashboard(projectID: string, name: string) {
    dispatch(setCurrentSelectedProject(Number(projectID)));
    dispatch(setProjectName(name));

    navigation.navigate(Routes.PROJECT, {
      screen: Routes.PROJECTDASHBOARD,
      params: {id: projectID},
    } as any);
  }

  return (
    <View style={styles.container}>
      <LinearGradient
        start={{x: 0, y: 0}}
        end={{x: 1, y: 1}}
        style={styles.dashboard}
        colors={[
          `${colors.palette.brandPink}16`,
          `${colors.palette.brandBlue}16`,
        ]}>
        {/* welcome me */}
        <Text style={styles.heading}>
          Welcome back, <Text style={[styles.heading, styles.name]}>{authData?.first_name}!</Text>
        </Text>

        {/* smart seach */}
        <SmartSearch navigation={navigation} />

        <View style={styles.insightsContainer}>
          {/* task insigts */}
          <TaskInsight />

          {/* performance insight insigts */}
          <PerformanceInsights />
        </View>

        <OngoingProjects
          goToProjectDashboard={goToProjectDashboard}
          goToViewAndManageProjects={goToViewAndManageProjects}
        />
      </LinearGradient>
    </View>
  );
}

type styleTypes = {
  container: ViewStyle;
  dashboard: ViewStyle;
  button: ViewStyle;
  listContainer: ViewStyle;
  heading: TextStyle;
  name: TextStyle;
  insightsContainer: ViewStyle;
};
const styles: styleTypes = StyleSheet.create({
  insightsContainer: {
    flexDirection: 'row',
    width: '100%',
    zIndex: -100,
    gap: spacing['6'],
  },
  heading: {
    fontWeight: 700,
    fontSize: 26,
  },
  name: {
    color: colors.palette.primaryP600,
  },

  container: {
    flex: 1,
    width: '100%',
    padding: spacing['6'],
  },
  dashboard: {
    flex: 1,
    borderRadius: corner_radius['rounded-lg'] + corner_radius.rounded,
    borderColor: colors.palette.neutralN400,
    borderWidth: 1,
    paddingVertical: spacing['4'],
    paddingHorizontal: spacing['4'],
    gap: spacing['4'],
  },
  button: {
    maxWidth: 100,
  },
  listContainer: {
    maxHeight: 100,
    border: '1px solid black',
  },
});
